import '@styles/components/appBannerCSC.less';
//import history from '@tools/history';
import { setTryOutDialog } from '@store/appSlice';
import { useAppDispatch } from '@hooks/reduxHooks';

const AppBannerCSC = () => {
  const dispatch = useAppDispatch();

  return (
    <div className={'app-banner'}>
      <img className={'banner-bg'} src={require('@images/common/sjdsBg.png').default} alt="" />
      <div className={'content'}>
        <div className={'logo'}>
          <img src={require('@images/common/CSD.png').default} alt="" />
        </div>
        <div className={'title'}>
          <span>设计大师</span>
        </div>
        <div className={'desc'}>公路、市政、铁路BIM设计软件 </div>
        <div className={'theme'}>
          <img src={require('@images/common/csdTheme.png').default} alt="" />
          <span>设计大师</span>
          <p>CivilStation Designer</p>
        </div>
        <div className={'operate'}>
          <span className={'free-csd'} onClick={() => dispatch(setTryOutDialog(true))}>
            申请试用
          </span>
          {/* <span className={'buy'} onClick={() => history.push('/buy')}>
            立即购买
          </span> */}
        </div>
      </div>
    </div>
  );
};

export default AppBannerCSC;
